import API from './api';

export default {
  loginUser(params) {
    return API.post('/auth/login', params);
  },
  logoutUser() {
    return API.post('/auth/logout', {});
  },
  checkAuth() {
    return API.get('/auth/me');
  },
  signUpUser(payload) {
    return API.post('/auth/signup', payload);
  },
  requestPasswordReset(email) {
    return API.post('/auth/request-password-reset', { email });
  },
  checkPasswordResetHash(password_reset_hash) {
    return API.get(
      `/auth/reset-password`,
      { params: { password_reset_hash } },
    );
  },
  resetPassword(payload) {
    return API.post('/auth/reset-password', payload);
  },
};
